import React from "react";
import "../styles/About.scss";
// import oculus from './header-background.avif'
import { motion } from "framer-motion";

const About = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        ease: "easeOut",
      },
    }),
  };

  return (
    <section id="about" className="about">
      <div className="about-container">
        {/* <div className="about-image">
          <img alt="About" src={oculus} width="368" height="245" style={{ width: '368px', height: 'auto' }} />
        </div> */}
        <div className="about-content">
          <h2>
            About
          </h2>
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={textVariants}
            custom={1}
          >
            With a background in computer science and shaped by 15+ years of front-end engineering, I specialize in turning complex systems into clear, expressive user experiences. My work spans early-stage startups, high-traffic streaming platforms, and the creation of design systems used across global banks and enterprise software organizations. I focus on building interfaces that are visually precise, technically sound, and built to scale.
          </motion.p>
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={textVariants}
            custom={2}
          >
            My perspective is shaped by years of working closely with engineers, designers, and business partners, often in the messy middle where ideas turn into real products. I balance strategy with hands-on execution, using modern front-end tools to build experiences that feel forward-looking without losing sight of real constraints.
          </motion.p>
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={textVariants}
            custom={3}
          >
            Outside of work, I’m a landscape photographer with a love for good coffee, and I stay curious by keeping up with what’s actually moving the needle in front-end development, design, and engineering.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default About;
